'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  return function (next) {
    return function (action) {
      next(action);
      _Raven2.default.setUser(store.getState());
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/middleware/RavenContextMiddleware.js
// module id = 538
// module chunks = 0